import React from "react";
var __jsx = React.createElement;
import useMoneyDisplay from "@lib/hooks/use-money-display";
import { getDayOfTheMonth } from "@lib/util/date-ops";
const CalendarDayContent = _ref => {
  let {
    date,
    price
  } = _ref;
  const showMoneyIfAvailable = process.env.NEXT_PUBLIC_SHOW_PRICE_IN_DAY === 'true';
  const noMoneyContent = __jsx(React.Fragment, null, getDayOfTheMonth(date));
  const money = useMoneyDisplay(price !== null && price !== void 0 ? price : 0);
  if (!price || !showMoneyIfAvailable) {
    return noMoneyContent;
  }
  return __jsx("div", {
    className: "flex flex-col justify-center items-center"
  }, __jsx("span", {
    className: "text-xs"
  }, getDayOfTheMonth(date)), __jsx("span", {
    className: "text-[6px]"
  }, money));
};
export default CalendarDayContent;